<template>
  <span v-if='value >= 0' :class='getClass'>
    {{ value }}
  </span>
</template>


<script>

export default {
  name: "WinCoef",
  props: {
    value: {
      type:  [Number, String],
    },
  },
  computed: {
    getClass() {
      if (this.value <= 1.5) return 'low';
      if (this.value <= 1.75) return 'middle';
      return 'strong';
    },
  }
}
</script>

<style lang="scss" scoped>
.low {
  color: var(--danger-color);
}

.middle {
  color: var(--warning-color);
}

.strong {
  color: var(--success-color);
}
</style>